"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsMobileWidth", {
    enumerable: true,
    get: function() {
        return useIsMobileWidth;
    }
});
const _react = require("react");
const _Theme = require("../contexts/Theme");
const _useWindowDimensions = require("./useWindowDimensions");
const useIsMobileWidth = function() {
    let breakpoint = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "lg";
    const { breakpoints } = (0, _Theme.useTheme)();
    const { width } = (0, _useWindowDimensions.useWindowDimensions)();
    const [isMobile, setIsMobile] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setIsMobile(width < breakpoints[breakpoint]);
    }, [
        width,
        breakpoint,
        breakpoints
    ]);
    return isMobile;
};

//# sourceMappingURL=useIsMobileWidth.js.map